import styled from '@emotion/styled'

export const TablePO = styled.div({
  width: '100%',
  paddingRight: '0.9357rem',

  '.ReactTable':{
    borderWidth:'0 !important'
  },

  '.-center': {
    visibility: 'hidden !important',
    height:'1rem',
    flex:6
  },

  '.-pagination':{
    boxShadow:'none !important',
    borderTop:'0 !important'
  },  

  '.rt-tr.-odd':{
    background:'none !important'
  },

  '.rt-tr.-even':{
    background:'none !important'
  },

  '.rt-tr-group':{
    borderBottom:'none !important'
  },

  '.rt-thead.-header':{
    display:'none !important'
  },

  '.rt-item':{
    display:'flex',
    justifyContent:'space-between',
    alignItems:'center',
    border:'1px solid rgba(34,36,38,.15)',
    padding:'0.4rem',
    borderRadius:'0.5rem',
    background: '#F5F6FA',
    fontWeight:'bold',
    '.wordTitle':{
      width: '26rem',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    }
  },

  '@media only screen and (min-width: 600px)': {
    width: '50%',
  },

  '@media only screen and (min-width: 769px)': {
    width: '50%',
  },
});

export const DType = styled.div({
  '.type':{
    'div.fieldRow':{
      marginBottom:'0.0625rem'
    },
  }, 

  '.subDeliveryTypeC':{
    '.fieldLabel':{
      display:'none !important',
    }
  }
});